import { EventEmitter, Injectable } from '@angular/core';
import { AppGlobalsServiceBase } from 'scaletech-core';
import { environment } from '../../environments/environment';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppGlobalsService extends AppGlobalsServiceBase {

  private _versionBeta: boolean = environment.testMode;
  private _versionSuffix = (this._versionBeta ? 'beta - ' : ' - ') + environment.packageDate;
  private _version: string = environment.VERSION;
  protected _timeZone = 'EDT';
  public get appVersion(): string { return this._version = `v. ${this._version} ${this._versionSuffix}`; }

  constructor() {
    super();
    this.locationChangedEmitter = new ReplaySubject<any>(1);
    this.locationChangedEmitter.next(null);
  }
}
